import {AxiosError} from 'axios';
import {POST_COORDINATOR_APPEAL_CHECK_ELIGIBILITY_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CheckEligibilityRequest {
  examCode: string;
  token: string | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorAppealCheckEligibility = ({onSuccess, onError}: Input = {}) => {
  const postCoordinatorAppealCheckEligibility = async (requestBody: CheckEligibilityRequest) => {
    const res = await axiosClient.post<void>(
        POST_COORDINATOR_APPEAL_CHECK_ELIGIBILITY_URL,
        requestBody
    );

    return res.data;
  };

  return useCustomMutation(
      postCoordinatorAppealCheckEligibility,
      {
        onSuccess,
        onError,
      },
      true,
      false
  );
};
